import { render, staticRenderFns } from "./CompanyDistrictPromotionList.vue?vue&type=template&id=1a015ec4&"
import script from "./CompanyDistrictPromotionList.vue?vue&type=script&lang=ts&"
export * from "./CompanyDistrictPromotionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports